import mentions from "../extensions/mentions"
import onEnterSubmit from "../extensions/on_enter_submit"
import linkConverter from "../extensions/link_converter"
import charsCounter from "../extensions/chars_counter"

const comments = {
  extensions: ["on_enter_submit", "link_converter", "chars_counter"],
  toolbarOptions() {
    return [
      ["bold", "italic", "underline", "strike"], // B, I, U buttons
      [{ list: "ordered" }, { list: "bullet" }], // Numbered and bullet lists
      ["link", "blockquote"],
    ]
  },
}

export default Object.assign(
  {},
  linkConverter,
  comments,
  mentions,
  onEnterSubmit,
  charsCounter,
)
